import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    eSpotAboveGrid: 'my-4 md:(mb-8 mt-6)',
    eSpotLazyAboveFooter: 'my-4 md:(mb-8 mt-6)',
    noResultsMessageInitialQuery: 'fw-medium',
    noResultsMessageQuery: 'fw-medium',
    productCount: 'hidden',
    title: 'title-2'
  },
  brandStyles: {
    searchBar: {
      w: {
        md: '36rem'
      }
    }
  },
  showAutoCorrect: true,
  showDidYouMean: true
} satisfies RecursivePartial<PagesConfig['search']>
